import { useHttpClientDispatchable } from "../../../common/modules/httpClient/hooks/useHttpClientDispatchable";
import { RequestMethodEnum } from "../../../common/modules/httpClient/enums/RequestMethodEnum";
import { INetwork } from "../../../entities/INetwork";

export const useAttachAssetService = (id: INetwork["id"]) =>
  useHttpClientDispatchable({
    url: `/networking/attachAsset/${id}`,
    method: RequestMethodEnum.PATCH,
  });
